import React from 'react';
import { getConfiguration, iconSportCssClass } from '../data/utils';
import { useAbsolutePath } from '../data/seo/seoRouteUtils';
import MainContext from '../contexts/MainContext';
import { SeoContext } from '../data/seo/SeoContextProvider';
import { handleCanonicalUrl } from '../data/seo/seoUtils';

function SportSelection(props) {
	const mainContext = React.useContext(MainContext);
    const seoContext = React.useContext(SeoContext);
	const selected = props.selected ? ' icona-selezionata' : '';
	const icoSport = iconSportCssClass(props.id, props.iconClass);
	const conf = getConfiguration();
	const sportPath = `${props.urlPath}${props.urlPathSuffix}`;
	const absoluteSportPathSeoLive  = useAbsolutePath(sportPath, null, props.urlPathSeoLive);

	function handleClick(e,url) {
		if(url) {
			e.preventDefault();
			e.stopPropagation();
			handleHistory(url);
		}
		props.changeSport(props.id);
	}
	
	function handleHistory(url) {
		if (window.history) {
			seoContext.refreshPathname(sportPath, mainContext.currentSection.current);
			handleCanonicalUrl(url);
			if (mainContext.historyNavigationEnabled) {
				if (window.location.pathname != url) {
					window.history.pushState(window.history.state, null, url);
				}
			} else {
				window.history.replaceState(window.history.state, null, url);
			}

		}
	}


    
	return ( props.isLive && props.urlPathSeoLive?
		<a href={absoluteSportPathSeoLive} className={"icona-slider-sport" + selected} style={{order: props.order}} onClick={(e) => {handleClick(e,absoluteSportPathSeoLive)}}>
			{conf.iwh ? 
			<figure className="sport-icona-live">
			
			<div className={`img-fluid ico-sport ${icoSport}`}></div>
			<span>{props.descrizione}</span>
			{(props.counter != null && props.counter > 0) &&
				<span className="contatore-live-icone contatore-live-icone-wh">({props.counter})</span>
			}
			</figure>
			:
			<figure className="sport-icona-live">
				{(props.counter != null && props.counter > 0) &&
					<span className="contatore-live-icone">{props.counter}</span>
				}
				<div className={`img-fluid ico-sport ${icoSport}`}></div>
				<span>{props.descrizione}</span>
			</figure>
			}
		</a>
		:
		<div className={"icona-slider-sport" + selected} style={{order: props.order}} onClick={(e) => {handleClick(e)}}>
			{conf.iwh ? 
			<figure className="sport-icona-live">
			
			<div className={`img-fluid ico-sport ${icoSport}`}></div>
			<span>{props.descrizione}</span>
			{(props.counter != null && props.counter > 0) &&
				<span className="contatore-live-icone contatore-live-icone-wh">({props.counter})</span>
			}
			</figure>
			:
			<figure className="sport-icona-live">
				{(props.counter != null && props.counter > 0) &&
					<span className="contatore-live-icone">{props.counter}</span>
				}
				<div className={`img-fluid ico-sport ${icoSport}`}></div>
				<span>{props.descrizione}</span>
			</figure>
			}
		</div>
    );
}

export default SportSelection;